<!--suppress JSNonASCIINames -->
<template>
  <vx-card>
    <div>
      <div class="flex justify-between items-center">
        <p style="font-size: 18px; font-weight: 700">항만(부두)</p>

        <FieldWriteButtonGroup
          :useCopy="isEditable && !!fieldId"
          :useDelete="isEditable && !!fieldId"
          :useSave="isEditable"
          @onClickCopy="onClickCopy"
          @onClickExcel="onClickDownloadExcel"
          @onClickDelete="onClickDelete"
          @onClickMoveList="onClickMoveList"
          @onClickSave="onClickSave"
        />
      </div>

      <!-- 기본정보 -->
      <div class="mt-28px">
        <h5 class="mb-4"><i class="dot"></i> 기본정보</h5>
        <div class="writeGridContainer">
          <div>
            <div>관리주체</div>
            <ml-input v-model="form.management_entity" :readonly="readonly" />
          </div>
          <div>
            <div>소유자</div>
            <ml-input v-model="form.owner" :readonly="readonly" />
          </div>
          <div>
            <div>전화번호</div>
            <ml-input v-model="form.phoneNumber" :readonly="readonly" placeholder="예) 055-123-4567" />
          </div>
          <div>
            <div>보관자</div>
            <ml-input v-model="form.custodian" :readonly="readonly" />
          </div>
          <div>
            <div>관리방법</div>
            <vs-select autocomplete v-model="form.관리방법">
              <vs-select-item text="직접관리" value="직접관리" />
              <vs-select-item text="위탁관리" value="위탁관리" />
            </vs-select>
          </div>
          <div>
            <div>소관부서</div>
            <ml-input v-model="form.소관부서" :readonly="readonly" />
          </div>
          <div>
            <div>담당팀</div>
            <ml-input v-model="form.담당팀" :readonly="readonly" />
          </div>
          <div>
            <div>담당주무관</div>
            <ml-input v-model="form.담당주무관" :readonly="readonly" />
          </div>
        </div>
      </div>
    </div>

    <!-- 시설물 정보 -->
    <port-write-body :form="form" :category-info="categoryInfo" :readonly="readonly" />

    <!-- 관리 부서 및 업체 등록 -->
    <company-add-module
      title="관리 부서 및 업체 등록"
      :tableColumns="[
        { head: '구분', key: 'com_type' },
        { head: '부서(업체)명', key: 'com_name' },
        { head: '연락처', key: 'phone' },
      ]"
      :isSimple="true"
      :readonly="readonly"
      v-model="companyList"
      @remove="removeCompany"
    />

    <!-- 전경사진 -->
    <photo-upload-grid-module :row-count="2" :grid-count="2" v-model="form.photoList" section-title="전경사진" placeholder="전경사진" :readonly="readonly" />

    <file-upload-module v-model="fileList" class="mt-28px" :readonly="readonly" target="field" />
    <FieldWriteButtonGroup
      :useCopy="isEditable && !!fieldId"
      :useDelete="isEditable && !!fieldId"
      :useSave="isEditable"
      @onClickCopy="onClickCopy"
      @onClickExcel="onClickDownloadExcel"
      @onClickDelete="onClickDelete"
      @onClickMoveList="onClickMoveList"
      @onClickSave="onClickSave"
    />
  </vx-card>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import CompanyAddModule from "@/views/_BS/components/CompanyAddModule";
import DateSelector from "@/components/selector/DateSelector";
import DateSelectorRang from "@/components/selector/DateSelectorRang";
import SignField from "@/components/SignField.vue";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import moment from "moment";
import PortWriteBody from "@/views/fields/single-page/port-dock/PortWriteBody.vue";
import BridgeWriteBody from "@/views/fields/single-page/bridge/BridgeWriteBody.vue";
import ExcelJS from "exceljs";
import FieldWriteButtonGroup from "@/views/fields/components/FieldWriteButtonGroup.vue";

export default {
  components: {
    BridgeWriteBody,
    PortWriteBody,
    FileUploadModule,
    CompanyAddModule,
    DateSelector,
    DateSelectorRang,
    SignField,
    PhotoUploadGridModule,
    FieldWriteButtonGroup,
  },
  data() {
    return {
      form: {
        phoneNumber: "",
        custodian: "",
        관리방법: "직접관리",
        소관부서: "",
        담당팀: "",
        담당주무관: "",

        facilityNumber: "",
        managementNumber: "",
        facilityName: "",
        routeDivision: "",
        routeDetail: "",

        facility_category_id: "",

        cat1: "",
        cat2: "",
        cat3: "",
        classification: "",

        socEvaluationTarget: "",
        address: "",
        management_entity: "",
        management_type: "",
        owner: "",
        ownerType: "",
        businessPlanApprovalDate: "",
        completionDate: "",
        defectLiabilityExpirationDate1: "",
        detailedSpecifications: "",
        safetyInspectionAndDiagnosisHistory: "",
        repairAndReinforcementHistory: "",
        accessibleVentCover: "",
        designPeriod: "",
        designer: "",
        defectLiabilityExpirationDate2: "",
        constructionPeriod: "",
        contractor: "",
        totalConstructionCost: "",
        seismicDesignTarget: "",
        seismicDesignApplication: "",
        seismicDesignStandard: "",
        seismicPerformanceEvaluation: "",
        seismicReinforcement: "",
        young21Target: "",
        auditPeriod: "",
        auditor: "",
        projectOwner: "",
        constructionName: "",
        defectLiabilityExpirationDate: "",
        constructionSupervisor: "",
        creationDate: moment().format("YYYY-MM-DD"),
        author: this.$store.state.auth.userInfo ? this.$store.state.auth.userInfo.name : "",
        signature: "",
        lastModifiedDate: "",
        lastModifiedBy: "",
        remarks: "",

        // 상세제원
        최대계류선박규모: "",
        연장: "",
        천단고: "",
        수심: "",
        항만구분: "",
        해역: "",
        부두폭: "",
        배면매립부길이: "",
        해저송유관길이: "",
        대표형식: "",
        중력식: {
          케이슨식: "",
          L형블럭: "",
          셀룰러블럭식: "",
          현장타설식: "",
        },
        잔교식: {
          말뚝식구경: "",
          말뚝식연장: "",
          말뚝식본수: "",
          원통식: "",
          교각식: "",
        },
        널말뚝식: {
          규격: "",
          기타: "",
        },

        otherSpecifications: "",

        companyList: [],
        photoList: [],
      },

      companyList: [],
      userList: [],
      joinUsers: [],
      fileList: [],
      categoryInfo: {
        facility_category_id: 0,
        cat1: "",
        cat2: "",
        cat3: "",
        classification: "",
      },

      catLock: true,
    };
  },
  computed: {
    projectId() {
      return Number(this.$route.params.proj_id);
    },
    fieldId() {
      return this.$route.params.fieldId;
    },
    myInfo() {
      return this.$store.state.auth.userInfo;
    },
    isAdmin() {
      let isAdmin = false;
      const myInfo = this.$store.state.auth.userInfo;
      isAdmin = isAdmin || parseInt(myInfo.is_superuser) > 0;
      return isAdmin;
    },
    /**
     * 현재 사용자가 프로젝트 관리자인지 확인합니다.
     * 프로젝트 관리자는 사업장을 등록/수정/삭제할 수 있습니다.
     * @returns {boolean}
     */
    isProjectManager() {
      const memberInfo = this.$store.state.member.memberInfo;
      if (memberInfo) {
        if (memberInfo.is_superuser) {
          return true;
        }

        const projects = memberInfo.projects;
        if (projects && projects.length > 0) {
          for (const project of projects) {
            if (`${project.id}` === `${this.projectId}`) {
              return project.pivot.is_manager;
            }
          }
        }
      }
      return false;
    },
    /**
     * 사업장을 프로젝트 관리자만 수정할 수 있는지 확인합니다.
     * @returns {boolean}
     */
    isFieldEditByManagerOnly() {
      const projectInfo = this.$store.state.project.projectInfo;

      return !!projectInfo.field_edit_by_manager_only;
    },
    isEditable() {
      if (this.isFieldEditByManagerOnly) {
        return this.isProjectManager;
      }
      return true;
    },
    readonly() {
      return !this.isEditable;
    },
  },
  watch: {
    async companyList() {
      await this.initMembers();
    },
  },
  async created() {
    await this.$store.dispatch("member/LOAD_MEMBER_DETAIL");
    await this.$store.dispatch("project/LOAD_PROJECT", { project_id: this.projectId });
  },
  async mounted() {
    if (this.fieldId) {
      await this.loadField();
    } else {
      this.form.담당팀 = (this.$store.state.auth.userInfo && this.$store.state.auth.userInfo.section) || "";
    }
  },
  methods: {
    async loadField() {
      const fieldId = this.fieldId;
      await this.$store.dispatch("project/LOAD_FIELD", { fieldId });
      const info = this.$store.state.project.fieldInfo;

      this.joinUsers = info.users;
      this.form = { ...this.form, ...info, ...JSON.parse(info.meta) };

      if (info.facility_category) {
        this.form.facility_category_id = info.facility_category.id;
        this.form.cat1 = info.facility_category.cat1;
        this.form.cat2 = info.facility_category.cat2;
        this.form.cat3 = info.facility_category.cat3;
        this.form.classification = info.facility_category.classification;

        this.categoryInfo = {
          facility_category_id: info.facility_category.id,
          cat1: info.facility_category.cat1,
          cat2: info.facility_category.cat2,
          cat3: info.facility_category.cat3,
          classification: info.facility_category.classification,
        };
      }

      if (this.form.companies && info.companies.length > 0) {
        const companies = [];
        for (const company of info.companies) {
          companies.push(company);
        }
        this.companyList = companies;

        await this.initMembers();
      }

      // 첨부파일
      this.form.fileList = info.attachments || [];
      if (this.form.fileList) {
        this.fileList = this.form.fileList;
      }

      // this.form.photoList 항목이 2개보다 적을 경우, 빈 항목을 추가한다.
      if (this.form.photoList.length < 2) {
        for (let i = this.form.photoList.length; i < 2; i++) {
          this.form.photoList.push({ id: "", url: "" });
        }
      }
    },

    async initMembers() {
      const joinUsers = this.joinUsers;
      const members = [];
      for (const company of this.companyList) {
        members.push(...(await this.loadMember(company.id)));
      }

      for (const member of members) {
        let join_project = false;
        for (const user of joinUsers) {
          if (user.id === member.id) {
            join_project = true;
            break;
          }
        }
        member.join_project = join_project;
      }

      this.userList = members;
    },

    async loadMember(company_id) {
      const page = 1;
      const perPage = 100;
      await this.$store.dispatch("company/LOAD_MEMBER_LIST", { page, perPage, company_id });
      return JSON.parse(JSON.stringify(this.$store.state.company.memberList));
    },

    removeCompany(company) {
      let i = 0;
      for (i = 0; i < this.joinUsers.length; i++) {
        const usr = this.joinUsers[i];
        if (usr.company_id === company.id) {
          this.joinUsers.splice(i, 1);
          i--;
        }
      }
    },

    customAlert(msg, title) {
      const customAlert = new CustomEvent("customAlert", {
        detail: {
          title: title ? title : "오류가 발생했습니다",
          message: msg,
        },
      });
      window.dispatchEvent(customAlert);
    },

    onClickSave(isCopy) {
      // 필수 : facilityName,
      if (!this.form.facilityName) {
        this.customAlert("시설물명을 입력해주세요.");
        return;
      }
      if (this.form.phoneNumber && !/^[0-9+()\-\s]+$/.test(this.form.phoneNumber)) {
        this.customAlert("전화번호는 숫자와 하이픈(-)만 입력할 수 있습니다.");
        return;
      }

      const option = {
        project_id: this.projectId, // 프로젝트 ID
        field_name: this.form.facilityName, // 현장(시설물, 사업장) 이름
        contract_code: this.form.facilityNumber, // 계약번호
        address: this.form.address, // 주소
        phone: this.form.phoneNumber, // 대표번호
        be_completed_at: this.form.completionDate, // 준공일
        deposit_amount: this.form.totalConstructionCost, // 총공사비
        facility_category_id: this.form.facility_category_id, // Category
        uploads: this.fileList.map((file) => file.id), // 파일
      };

      const company_ids = [];
      for (const com of this.companyList) {
        company_ids.push(com.id);
      }
      option.company_ids = company_ids;

      if (this.fieldId) {
        const user_ids = [];
        if (this.joinUsers.length > 0) {
          for (const user of this.joinUsers) {
            user_ids.push(user.id);
          }
        }
        option.user_ids = user_ids;
      }
      if (isCopy) {
        option.meta = {
          ...this.form,
          creationDate: moment().format("YYYY-MM-DD"),
          author: this.myInfo.name,
          lastModifiedDate: moment().format("YYYY-MM-DD"),
          lastModifiedBy: this.myInfo.name,
        };
        this.$emit("copy", option);
      } else {
        // Meta
        option.meta = { ...this.form, lastModifiedDate: moment().format("YYYY-MM-DD"), lastModifiedBy: this.myInfo.name };

        this.$emit("save", option);
      }
    },
    onClickCopy() {
      this.onClickSave(true);
    },
    onClickDelete() {
      if (!this.fieldId) return;
      this.$emit("delete", this.fieldId);
    },
    onClickMoveList() {
      this.$emit("moveList");
    },
    async onClickDownloadExcel() {
      // 엑셀 파일 가져오기
      // 파일은 public/fms/ 경로에 저장되어 있다.
      const response = await fetch("/fms/시설물관리대장_항만_부두.xlsx");
      const arrayBuffer = await response.arrayBuffer();

      const workbook = new ExcelJS.Workbook();
      await workbook.xlsx.load(arrayBuffer);

      // 첫번째 시트의 이름 가져오기
      const worksheet = workbook.worksheets[0];

      // 시트에 데이터 입력하기
      this.applyDataToSheet(worksheet);

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

      let fileName = "";
      if (this.form.facilityName) {
        if (this.form.facilityNumber) {
          fileName = `시설물관리대장(계류시설)_${this.form.facilityName}_${this.form.facilityNumber}`;
        } else {
          fileName = `시설물관리대장(계류시설)_${this.form.facilityName}`;
        }
      } else if (this.form.facilityNumber) {
        fileName = `시설물관리대장(계류시설)_${this.form.facilityNumber}`;
      } else {
        fileName = `시설물관리대장(계류시설)`;
      }
      fileName += ".xlsx";

      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    },
    applyDataToSheet(worksheet) {
      const cellMatchInfo = {
        facilityNumber: ["T4", "B20"], // 시설물번호
        managementNumber: ["T5", "I20"], // 관리번호
        facilityName: ["T6", "N20", "B41"], // 시설물명
        management_entity: ["S13", "Q22"], // 관리주체
        owner: ["S14"], // 소유자
        custodian: ["S15"], // 보관자
        routeDivision: ["W20"], // 노선-구분
        routeDetail: ["AB20"], // 노선-세부노선
        cat1: ["AO20"], // 시설물구분
        cat3: ["AG20"], // 시설물종류
        classification: ["AK20"], // 시설물종별
        socEvaluationTarget: ["AU20"], // SOC성능평가대상
        address: ["B22"], // 주소
        businessPlanApprovalDate: ["B27"], // 사업계획승인일
        completionDate: ["F27"], // 준공일
        defectLiabilityExpirationDate1: ["M27"], // 하자보수보증종료일
        detailedSpecifications: ["R27"], // 상세제원
        safetyInspectionAndDiagnosisHistory: ["V27"], // 안전점검진단이력
        repairAndReinforcementHistory: ["AC27"], // 보수보강이력
        accessibleVentCover: ["AI27"], // 통풍구방법
        designer: ["P29"], // 설계자
        contractor: ["AH29"], // 시공자
        totalConstructionCost: ["AQ29"], // 총공사비
        seismicDesignTarget: ["E31"], // 지진설계대상
        seismicDesignApplication: ["P31"], // 지진설계적용
        seismicDesignStandard: ["X31"], // 지진설계기준
        seismicPerformanceEvaluation: ["AH31"], // 지진성능평가
        seismicReinforcement: ["AQ31"], // 지진보강
        young21Target: ["B33"], // 영21조대상
        auditor: ["P33"], // 감리자
        projectOwner: ["X33"], // 사업주체
        constructionName: ["AH33"], // 공사명
        constructionSupervisor: ["AQ33"], // 공사감독
        creationDate: ["B36"], // 작성일
        lastModifiedDate: ["Y36"], // 최종 수정일
        lastModifiedBy: ["AL36"], // 최종 수정자
        remarks: ["D37"], // 비고

        // 상세제원
        최대계류선박규모: ["O41"], // 최대계류선박규모
        연장: ["U41"], // 연장
        천단고: ["AK41"], // 천단고
        수심: ["AS41"], // 수심

        항만구분: ["B43"], // 항만구분
        해역: ["O43"], // 해역
        부두폭: ["U43"], // 부두폭
        배면매립부길이: ["AE43"], // 배면매립부길이
        해저송유관길이: ["AK43"], // 해저송유관길이
        대표형식: ["AS43"], // 대표형식

        // 중력식
        케이슨식: ["O45"], // 케이슨식
        L형블럭: ["U45"], // L형블럭
        셀룰러블럭식: ["AK45"], // 셀룰러블럭식
        현장타설식: ["AS45"], // 현장타설식

        // 잔교식
        말뚝식구경: ["O48"], // 말뚝식구경
        말뚝식연장: ["U48"], // 말뚝식연장
        말뚝식본수: ["AE48"], // 말뚝식본수
        원통식: ["AK48"], // 원통식
        교각식: ["AS48"], // 교각식

        // 널말뚝식
        규격: ["O50"], // 규격
        기타: ["AK50"], // 기타

        otherSpecifications: ["O51"], // 기타사항
      };

      for (const key in cellMatchInfo) {
        const cell = cellMatchInfo[key];
        for (const c of cell) {
          worksheet.getCell(c).value = this.form[key] ? this.form[key] : "";
        }
      }

      worksheet.getCell("V25").value = "";
      worksheet.getCell("Z25").value = "";
      worksheet.getCell("AD25").value = "";
      worksheet.getCell("AG23").value = "";
      if (this.form.management_type === "중앙부처") {
        worksheet.getCell("V25").value = "V";
      } else if (this.form.management_type === "지자체") {
        worksheet.getCell("Z25").value = "V";
      } else if (this.form.management_type === "(국가/지방)공기업") {
        worksheet.getCell("AD25").value = "V";
      } else if (this.form.management_type === "민간") {
        worksheet.getCell("AG23").value = "V";
      }

      worksheet.getCell("AM25").value = "";
      worksheet.getCell("AR25").value = "";
      worksheet.getCell("AT25").value = "";
      worksheet.getCell("AV23").value = "";
      if (this.form.ownerType === "중앙부처") {
        worksheet.getCell("AM25").value = "V";
      } else if (this.form.ownerType === "지자체") {
        worksheet.getCell("AR25").value = "V";
      } else if (this.form.ownerType === "(국가/지방)공기업") {
        worksheet.getCell("AT25").value = "V";
      } else if (this.form.ownerType === "민간") {
        worksheet.getCell("AV23").value = "V";
      }

      // 전화번호 (AF14)
      worksheet.getCell("AF14").value = `전화번호: ${this.form.phoneNumber}`;

      // 첨부자료 목록 (AN27)
      const fileNames = this.fileList.map((file) => file.originalName).join(", ");
      worksheet.getCell("AN27").value = fileNames;

      // 설계기간 (B29)
      worksheet.getCell("B29").value = `${this.form.designPeriod.sDate} ~ ${this.form.designPeriod.eDate}`;

      // 공시기간 (X29)
      worksheet.getCell("X29").value = `${this.form.constructionPeriod.sDate} ~ ${this.form.constructionPeriod.eDate}`;

      // 감리기간 (E33)
      worksheet.getCell("E33").value = `${this.form.auditPeriod.sDate} ~ ${this.form.auditPeriod.eDate}`;

      // 작성자 (K36)
      worksheet.getCell("K36").value = `${this.form.author}  (인)`;

      // 빈칸으로 만들 칸들 (C22, G22, L22, L24, H43)
      const emptyCells = ["C22", "G22", "L22", "L24", "H43"];
      for (const cell of emptyCells) {
        worksheet.getCell(cell).value = "";
      }
    },
  },
};
</script>

<style scoped lang="scss">
table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  th,
  td {
    font-size: 14px;
    font-weight: 500;
    text-align: center;

    border: 1px solid #cdcdcd;
    padding: 5px;
  }

  th {
    background: #f9f9f9;
    padding: 10px 4px;
  }
}
</style>
<style scoped lang="scss">
.table-list {
  .action-button {
    margin-left: auto;
  }
}

.title {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
  position: relative;
  padding-left: 12px;

  &::before {
    content: "";
    width: 8px;
    height: 8px;
    background: #7e72f2;
    display: block;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: -8px;
    border-radius: 100%;
  }
}

.title-n {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
}

.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}

.size-search {
  width: 200px;
}

.input-se {
  width: 100%;

  &::v-deep .start-end-title {
    width: 114px;
    font-weight: 500;
    font-size: 14px;
    justify-content: flex-start;
  }

  &::v-deep .mr-2 {
    flex: 1;
    margin-right: 10px !important;
  }

  &::v-deep .mr-2 + .mr-2 {
    margin-right: 0 !important;

    &::before {
      content: "~";
      margin-right: 10px;
    }
  }

  &::v-deep .inline-block {
    width: 100% !important;
  }
}

.vs-table-primary .is-selected {
  background: rgba(126, 114, 242, 0.6) !important;
  color: white;
}

.search-item {
  width: 100% !important;
  margin: 0 !important;

  &::v-deep > div:first-child {
    width: 114px !important;
    font-weight: 500;
    font-size: 14px;
  }

  &::v-deep > div:last-child {
    flex: 1 !important;

    .con-select {
      width: 100%;
    }
  }
}

.upload-img {
  width: 100%;
  height: 318px !important;
  margin-top: 22px;
}
</style>

<style lang="scss">
.none-card {
  box-shadow: none;
  border-radius: 0;
  display: inline-block;

  .vx-card__body {
    padding: 0 !important;
  }
}

span.up {
  color: #28c76f;
}

span.down {
  color: #ea5455;
}

.vs-table--tbody-table tr:nth-child(2n) {
  background-color: #f9f9f9;
}
</style>
